import { BaseButton } from '@/app/components/buttons/BaseButton';
import { Modal } from '@/app/components/Modal';
import { Spinner } from '@/app/components/Spinner';

interface ViewDocumentModalLoadingProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ViewDocumentModalLoading = ({ isOpen, onClose }: ViewDocumentModalLoadingProps) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
    <div className="flex flex-col items-center text-center w-full min-w-[600px] max-w-[600px] max-h-[90vh]">
      <div className="px-[36px] pt-[46px]">
        <h2 className="light text-blue-900 whitespace-pre-line">Document information</h2>
        <p className="text-body-regular text-grey-700 text-center mb-4 mt-[6px]">Loading passport details…</p>
      </div>
      <div className="flex min-h-[200px] w-full items-center justify-center px-[36px]" aria-busy="true" aria-label="Loading">
        <Spinner />
      </div>
      <div className="w-full px-[36px] pb-[46px] pt-4">
        <BaseButton intent="secondary" onClick={onClose} size="full">
          Cancel
        </BaseButton>
      </div>
    </div>
  </Modal>
  );
};